module.exports = {"npm_package_version":"1.0.0"}


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/environments/.env.json
// module id = ../../../../../src/environments/.env.json
// module chunks = main